/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link, useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useEffect, useState } from "react";

function Breadcrumbs({ icon, title, route, light }) {
  const routeName = useLocation().pathname.split("/").slice(1);
  const routes = route.slice(0, -1);

  function isUUID(str) {
    const regex =
      /^[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}$/;
    return regex.test(str);
  }

  function getDisplayName(el, index) {
    if (el === "Fuentes") {
      return "Fuentes";
    } else if (isUUID(el) && index === 1 && routeName[0] === "Fuentes") {
      return "Archivos por fuente";
    } else if (isUUID(el) && index === 2) {
      return "Carnets por archivo";
    } else if (el === "verify") {
      return "Verificar carnets";
    } else {
      return el;
    }
  }

  function getDisplayNameEnd(title) {
    if (isUUID(title) && routeName.length === 2 && routeName[0] === "Fuentes") {
      return "Archivos por fuente";
    } else if (
      isUUID(title) &&
      routeName.length === 3 &&
      routeName[0] === "Fuentes" &&
      routeName[2] !== "formulario"
    ) {
      return nameSource;
    } else if (routeName[0] === "event-form") {
      return "Formulario";
    } else if (title === "card_type") {
      return "Tipos de carnet";
    } else if (title === "verify") {
      return "Verificar carnets";
    } else if (title === "verify_events") {
      return "Verificar eventos";
    } else if (title === "Bienvenida" || title === "bienvenida") {
      return "Bienvenida";
    } else if (routeName.length === 2 && routeName[0] === "Roles") {
      return "Editar rol";
    }
    if (
      (isUUID(title) && routeName.length === 2 && routeName[0] === "verify") ||
      (routeName.length >= 3 &&
        routeName[0] === "verify" &&
        isUUID(routeName[1]) &&
        (routeName[2] === "false" || routeName[2] === "true" || routeName[2] === ""))
    ) {
      return "Detalle del carnet";
    } else {
      return title;
    }
  }

  const [nameSource, setNameSource] = useState("");
  const [eventFormName, setEventFormName] = useState("");
  // const { nameFile, nameSource } = location.state || {};

  useEffect(() => {
    // Recuperar datos de sessionStorage
    const storedNameSource = sessionStorage.getItem("nameSource");
    const storedEventFormName = sessionStorage.getItem("eventFormName");

    if (storedNameSource) setNameSource(storedNameSource);
    if (storedEventFormName) setEventFormName(storedEventFormName);
  }, []);
  let fullPath = "";

  /**
   * Determina si un elemento de ruta debe excluirse de las migas de pan
   * @param {string} element - Elemento de la ruta
   * @returns {boolean} - true si debe excluirse
   */
  const shouldExcludeFromBreadcrumb = (element) => {
    const isVerifyRoute = routeName[0] === "verify";
    const isBooleanString = element === "true" || element === "false";

    return isVerifyRoute && (isUUID(element) || isBooleanString);
  };

  // Filtrar rutas para excluir UUIDs y valores booleanos en verificación
  const filteredRoutes = routes.filter((el) => !shouldExcludeFromBreadcrumb(el));
  return (
    <MDBox mr={{ xs: 0, xl: 8 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
          },
        }}
      >
        <Link to="/">
          <MDTypography
            component="span"
            variant="body2"
            color={light ? "white" : "dark"}
            opacity={light ? 0.8 : 0.5}
            sx={{ lineHeight: 0 }}
          >
            <Icon>{icon}</Icon>
          </MDTypography>
        </Link>
        {filteredRoutes.map((el, index) => {
          fullPath += `/${el}`;

          // Si es event-form, mostrar "Fuentes" en lugar de "event-form"
          if (el === "event-form") {
            return (
              <Link to="/Fuentes" key={index}>
                <MDTypography
                  component="span"
                  variant="button"
                  fontWeight="regular"
                  textTransform="none"
                  color={light ? "white" : "dark"}
                  opacity={light ? 0.8 : 0.5}
                  sx={{ lineHeight: 0 }}
                >
                  Fuentes
                </MDTypography>
              </Link>
            );
          }

          return (
            <Link to={fullPath} key={index}>
              <MDTypography
                component="span"
                variant="button"
                fontWeight="regular"
                textTransform="none"
                color={light ? "white" : "dark"}
                opacity={light ? 0.8 : 0.5}
                sx={{ lineHeight: 0 }}
              >
                {getDisplayName(el, index)}
              </MDTypography>
            </Link>
          );
        })}
        <MDTypography
          variant="button"
          fontWeight="regular"
          textTransform="none"
          color={light ? "white" : "dark"}
          sx={{ lineHeight: 0 }}
        >
          {getDisplayNameEnd(title)}
        </MDTypography>
      </MuiBreadcrumbs>
      <div>
        {/*<MDTypography
          fontWeight="bold"
          textTransform="capitalize"
          variant="h4"
          color={light ? "white" : "dark"}
          noWrap
        >
          {title.replace("-", " ")}
        </MDTypography>*/}
      </div>
    </MDBox>
  );
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
  light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;
